import React from "react";

const fmt = (n) => "Rp " + (n || 0).toLocaleString("id-ID", { maximumFractionDigits: 0 });
const terbilang = (n) => {
  // Simple Indonesian terbilang
  if (!n || n < 0) return "Nol Rupiah";
  const satuan = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan", "Sepuluh", "Sebelas"];
  function recursive(num) {
    num = Math.floor(num);
    if (num < 12) return satuan[num];
    if (num < 20) return recursive(num - 10) + " Belas";
    if (num < 100) return recursive(Math.floor(num / 10)) + " Puluh " + recursive(num % 10);
    if (num < 200) return "Seratus " + recursive(num - 100);
    if (num < 1000) return recursive(Math.floor(num / 100)) + " Ratus " + recursive(num % 100);
    if (num < 2000) return "Seribu " + recursive(num - 1000);
    if (num < 1000000) return recursive(Math.floor(num / 1000)) + " Ribu " + recursive(num % 1000);
    if (num < 1000000000) return recursive(Math.floor(num / 1000000)) + " Juta " + recursive(num % 1000000);
    return recursive(Math.floor(num / 1000000000)) + " Milyar " + recursive(num % 1000000000);
  }
  return recursive(n).replace(/\s+/g, " ").trim() + " Rupiah";
};

const formatTanggal = (iso) => {
  if (!iso) return "-";
  const [y, m, d] = iso.split("-");
  const bulan = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
  return `${parseInt(d, 10)} ${bulan[parseInt(m, 10) - 1]} ${y}`;
};

export default function SlipGaji({ data }) {
  if (!data) return null;
  const isPaid = data.payment_status === "Terbayar";
  return (
    <div className="slip-print" style={{ background: "white", padding: 24, border: "1px solid #828790", maxWidth: 800, margin: "0 auto", fontFamily: "Segoe UI, Tahoma, sans-serif", position: "relative" }}>
      {/* STAMP overlay */}
      <div
        className="slip-stamp"
        style={{
          position: "absolute",
          top: 100,
          right: 30,
          transform: "rotate(-20deg)",
          border: `4px solid ${isPaid ? "#4f8a10" : "#d8000c"}`,
          color: isPaid ? "#4f8a10" : "#d8000c",
          padding: "8px 18px",
          fontWeight: 900,
          fontSize: 26,
          letterSpacing: 2,
          opacity: 0.85,
          background: "rgba(255,255,255,0.6)",
          textAlign: "center",
          lineHeight: 1.1,
          zIndex: 5,
          pointerEvents: "none",
        }}
      >
        {isPaid ? "TERBAYAR" : "PENDING"}
        <div style={{ fontSize: 10, fontWeight: 600, marginTop: 2 }}>
          {isPaid && data.payment_date ? data.payment_date : "Belum dibayarkan"}
        </div>
      </div>
      {/* Company Header */}
      <div className="slip-header" style={{ borderBottom: "3px double #003399", paddingBottom: 12, marginBottom: 16, display: "flex", alignItems: "center", gap: 14 }}>
        <img
          src="/logo-fivehoster.png"
          alt="PT. Fivehoster"
          style={{ width: 72, height: 72, objectFit: "contain", flexShrink: 0, borderRadius: 6 }}
        />
        <div style={{ flex: 1, lineHeight: 1.3 }}>
          <h1 style={{ margin: 0, fontSize: 18, color: "#003399", fontWeight: 800, letterSpacing: 0.5 }}>
            PT. FIVEHOSTER KARYA BANGSA
          </h1>
          <div style={{ fontSize: 11, color: "#333", marginTop: 2 }}>
            Jl. Sawah Lunto RT.27 RW.07 Jeru, Kec. Turen, Kab. Malang
          </div>
          <div style={{ fontSize: 11, color: "#333" }}>
            Telp: <strong>031 30004702</strong>
          </div>
        </div>
        <div style={{ textAlign: "right", fontSize: 10, color: "#555" }}>
          <div>No. Slip:</div>
          <div style={{ fontFamily: "Consolas, monospace", fontWeight: 700, fontSize: 12, color: "#003399" }}>
            SLP/{data.periode_bulan?.replace("-", "")}/{data.no_karyawan}
          </div>
        </div>
      </div>

      <div className="slip-title-block" style={{ textAlign: "center", marginBottom: 14 }}>
        <h2 style={{ margin: 0, color: "#003399", fontSize: 16, letterSpacing: 1 }}>SLIP GAJI KARYAWAN</h2>
        <div style={{ fontSize: 12, color: "#555", marginTop: 4 }}>
          <strong>Periode:</strong> {formatTanggal(data.periode_mulai)} s/d {formatTanggal(data.periode_akhir)}
          {" "}&middot;{" "}
          <strong>Tanggal Bayar:</strong> {formatTanggal(data.tanggal_bayar)}
        </div>
      </div>

      {/* Employee info */}
      <table style={{ width: "100%", fontSize: 12, marginBottom: 12, borderCollapse: "collapse" }}>
        <tbody>
          <tr>
            <td style={tdLabel}>No. Karyawan</td><td style={tdValue}>: {data.no_karyawan}</td>
            <td style={tdLabel}>Divisi</td><td style={tdValue}>: {data.divisi}</td>
          </tr>
          <tr>
            <td style={tdLabel}>Nama</td><td style={tdValue}>: <strong>{data.nama_lengkap}</strong></td>
            <td style={tdLabel}>Jabatan</td><td style={tdValue}>: {data.jabatan}</td>
          </tr>
          <tr>
            <td style={tdLabel}>Metode Bayar</td>
            <td style={tdValue} colSpan={3}>
              :{" "}
              {data.metode_gaji === "Cash" ? (
                <span className="vb-badge vb-badge-terlambat">CASH / TUNAI</span>
              ) : (
                <span className="vb-badge vb-badge-izin">TRANSFER BANK</span>
              )}
              {data.metode_gaji === "Transfer" && data.bank_nama && (
                <span style={{ marginLeft: 8 }}>
                  <strong>{data.bank_nama}</strong>
                  {data.bank_rekening && <> &middot; No. Rek: <strong>{data.bank_rekening}</strong></>}
                  {data.bank_atas_nama && <> &middot; a.n. {data.bank_atas_nama}</>}
                </span>
              )}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Breakdown rate */}
      <div className="slip-breakdown" style={{ background: "#f5f9ff", padding: 8, fontSize: 11, marginBottom: 10, border: "1px solid #c4d9f1", borderLeft: "3px solid #003399" }}>
        <strong>Breakdown Gaji:</strong> {fmt(data.gaji_bulanan)} / bulan
        &nbsp;|&nbsp; {fmt(data.daily_rate)} / hari ({data.working_days_standard} hari kerja)
        &nbsp;|&nbsp; {fmt(data.hourly_rate)} / jam ({data.working_hours_per_day} jam/hari)
      </div>

      {/* Pendapatan */}
      <h3 style={{ fontSize: 13, color: "#003399", marginBottom: 6, marginTop: 8 }}>A. PENDAPATAN</h3>
      <table className="vb-table" style={{ fontSize: 12, marginBottom: 10 }}>
        <tbody>
          <tr><td>Gaji Pokok Bulanan ({data.jenis_gaji})</td><td style={{ textAlign: "right", width: 160 }}>{fmt(data.gaji_bulanan)}</td></tr>
          {data.tunjangan_detail && data.tunjangan_detail.length > 0 ? (
            <>
              <tr style={{ background: "#eef5ff" }}>
                <td colSpan={2} style={{ fontWeight: 600, color: "#003399", fontSize: 11, padding: "4px 8px" }}>
                  Tunjangan ({data.tunjangan_detail.length} item):
                </td>
              </tr>
              {data.tunjangan_detail.map((t, i) => (
                <tr key={i}>
                  <td style={{ paddingLeft: 24 }}>
                    &middot; Tunjangan {t.nama}
                    <span style={{ color: "#666", fontSize: 11 }}> — {t.jenis}, {t.periode} ({fmt(t.nominal)}{t.periode !== "Bulanan" ? `/${t.periode === "Harian" ? "hari" : "minggu"}` : ""})</span>
                  </td>
                  <td style={{ textAlign: "right" }}>{fmt(t.subtotal)}</td>
                </tr>
              ))}
              <tr style={{ background: "#f9f9f9", fontWeight: 600 }}>
                <td style={{ paddingLeft: 24, fontSize: 11 }}>Sub-total Tunjangan</td>
                <td style={{ textAlign: "right" }}>{fmt(data.total_tunjangan)}</td>
              </tr>
            </>
          ) : (
            <tr><td style={{ color: "#888", fontStyle: "italic" }}>Tidak ada tunjangan aktif</td><td style={{ textAlign: "right" }}>Rp 0</td></tr>
          )}
          <tr style={{ background: "#dff2bf", fontWeight: 700 }}>
            <td>Total Pendapatan (Gaji Kotor)</td>
            <td style={{ textAlign: "right" }}>{fmt(data.gaji_kotor)}</td>
          </tr>
        </tbody>
      </table>

      {/* Potongan */}
      <h3 style={{ fontSize: 13, color: "#d8000c", marginBottom: 6 }}>B. POTONGAN</h3>
      <table className="vb-table" style={{ fontSize: 12, marginBottom: 10 }}>
        <tbody>
          <tr>
            <td>Potongan Tidak Hadir ({data.total_tidak_hadir} hari × {fmt(data.daily_rate)})</td>
            <td style={{ textAlign: "right", width: 160 }}>{fmt(data.potongan_tidak_hadir)}</td>
          </tr>
          <tr>
            <td>Potongan Terlambat ({data.total_terlambat_count} kali, total {data.total_jam_potongan} jam × {fmt(data.hourly_rate)})</td>
            <td style={{ textAlign: "right" }}>{fmt(data.potongan_terlambat)}</td>
          </tr>
          {data.potongan_kasbon > 0 && (
            <>
              <tr style={{ background: "#fff3cd" }}>
                <td colSpan={2} style={{ fontWeight: 600, color: "#9F6000", fontSize: 11, padding: "4px 8px" }}>
                  Cicilan Kasbon ({data.kasbon_detail?.length || 0} aktif):
                </td>
              </tr>
              {data.kasbon_detail?.map((kb, i) => (
                <tr key={i}>
                  <td style={{ paddingLeft: 24 }}>
                    &middot; Kasbon (pinjam {kb.tanggal_pinjam}, total {fmt(kb.nominal_total)})
                  </td>
                  <td style={{ textAlign: "right" }}>{fmt(kb.cicilan_periode_ini)}</td>
                </tr>
              ))}
              <tr style={{ background: "#f9f9f9", fontWeight: 600 }}>
                <td style={{ paddingLeft: 24, fontSize: 11 }}>Sub-total Cicilan Kasbon</td>
                <td style={{ textAlign: "right" }}>{fmt(data.potongan_kasbon)}</td>
              </tr>
            </>
          )}
          {data.potongan_koperasi > 0 && (
            <>
              <tr style={{ background: "#e2d6f3" }}>
                <td colSpan={2} style={{ fontWeight: 600, color: "#5b3a8e", fontSize: 11, padding: "4px 8px" }}>
                  Belanja Koperasi ({data.koperasi_detail?.length || 0} transaksi):
                </td>
              </tr>
              {data.koperasi_detail?.map((kp, i) => (
                <tr key={i}>
                  <td style={{ paddingLeft: 24 }}>
                    &middot; {kp.no_transaksi} — {kp.vendor_nama} ({kp.tanggal})
                  </td>
                  <td style={{ textAlign: "right" }}>{fmt(kp.nominal)}</td>
                </tr>
              ))}
              <tr style={{ background: "#f9f9f9", fontWeight: 600 }}>
                <td style={{ paddingLeft: 24, fontSize: 11 }}>Sub-total Belanja Koperasi</td>
                <td style={{ textAlign: "right" }}>{fmt(data.potongan_koperasi)}</td>
              </tr>
            </>
          )}
          <tr style={{ background: "#ffbaba", fontWeight: 700 }}>
            <td>Total Potongan</td>
            <td style={{ textAlign: "right" }}>{fmt(data.total_potongan)}</td>
          </tr>
        </tbody>
      </table>

      {/* Detail potongan */}
      {data.detail_potongan?.length > 0 && (
        <>
          <h4 style={{ fontSize: 11, color: "#555", marginBottom: 4 }}>Detail Potongan</h4>
          <table className="vb-table" style={{ fontSize: 11, marginBottom: 10 }}>
            <thead><tr><th>Tanggal</th><th>Alasan</th><th>Jam</th><th style={{ textAlign: "right" }}>Nominal</th></tr></thead>
            <tbody>
              {data.detail_potongan.map((d, i) => (
                <tr key={i}>
                  <td>{d.tanggal}</td>
                  <td>{d.alasan}</td>
                  <td>{d.jam_potongan}</td>
                  <td style={{ textAlign: "right" }}>{fmt(d.nominal_potongan)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      {/* Summary kehadiran */}
      <h3 style={{ fontSize: 13, color: "#003399", marginBottom: 6 }}>C. REKAP KEHADIRAN</h3>
      <table className="vb-table" style={{ fontSize: 12, marginBottom: 10 }}>
        <tbody>
          <tr><td>Hadir</td><td style={{ textAlign: "right" }}>{data.total_hadir} hari</td></tr>
          <tr><td>Tidak Hadir</td><td style={{ textAlign: "right" }}>{data.total_tidak_hadir} hari</td></tr>
          <tr><td>Izin</td><td style={{ textAlign: "right" }}>{data.total_izin} hari</td></tr>
          <tr><td>Sakit</td><td style={{ textAlign: "right" }}>{data.total_sakit} hari</td></tr>
          <tr><td>Terlambat</td><td style={{ textAlign: "right" }}>{data.total_terlambat_count} kali / {data.total_terlambat_menit} menit</td></tr>
        </tbody>
      </table>

      {/* Total */}
      <div className="slip-total" style={{ marginTop: 14, padding: 14, background: "linear-gradient(to right, #003399, #0055cc)", color: "white", borderRadius: 4 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontSize: 13, fontWeight: 700, letterSpacing: 1 }}>GAJI BERSIH DITERIMA</span>
          <span style={{ fontSize: 22, fontWeight: 800 }}>{fmt(data.gaji_bersih)}</span>
        </div>
        <div style={{ fontSize: 11, fontStyle: "italic", marginTop: 6, borderTop: "1px solid rgba(255,255,255,0.3)", paddingTop: 6 }}>
          Terbilang: <strong>{terbilang(data.gaji_bersih)}</strong>
        </div>
      </div>

      {/* Payment method confirmation */}
      <div className="slip-payment-info" style={{ marginTop: 14, padding: 10, background: "#FFFFE1", border: "1px solid #828790", fontSize: 12 }}>
        {data.metode_gaji === "Transfer" ? (
          <>
            <strong>Metode Pembayaran: TRANSFER BANK</strong><br />
            Gaji akan ditransfer ke rekening:
            <ul style={{ margin: "4px 0 0 16px", padding: 0 }}>
              <li>Bank: <strong>{data.bank_nama || "-"}</strong></li>
              <li>No. Rekening: <strong>{data.bank_rekening || "-"}</strong></li>
              <li>Atas Nama: <strong>{data.bank_atas_nama || "-"}</strong></li>
            </ul>
          </>
        ) : (
          <>
            <strong>Metode Pembayaran: CASH / TUNAI</strong><br />
            Silakan ambil gaji di kantor pada tanggal bayar yang tertera. Harap membawa kartu identitas.
          </>
        )}
      </div>

      <div className="slip-footer" style={{ marginTop: 20, display: "flex", justifyContent: "space-between", fontSize: 11, color: "#555" }}>
        <div>
          <em>Dokumen ini sah tanpa tanda tangan dan stempel basah.</em><br />
          Dicetak: {new Date().toLocaleString("id-ID")}<br />
          <span style={{ fontSize: 10 }}>© PT. Fivehoster Karya Bangsa - Sistem SIMAK</span>
        </div>
        <div style={{ textAlign: "center" }}>
          Malang, {formatTanggal(data.tanggal_bayar)}<br />
          <strong>Bagian HRD</strong><br /><br /><br />
          <span style={{ borderTop: "1px solid #555", paddingTop: 2 }}>__________________</span>
        </div>
      </div>
    </div>
  );
}

const tdLabel = { padding: 3, fontWeight: 600, width: 110, fontSize: 12, verticalAlign: "top" };
const tdValue = { padding: 3, fontSize: 12, verticalAlign: "top" };
